// extracted by mini-css-extract-plugin
export var boldText = "_54-4";
export var checkboxContainer = "_54-6";
export var closeIcon = "_54-i";
export var container = "_54-0";
export var drawer = "_54-8";
export var drawerContent = "_54-9";
export var extraSmallText = "_54-5";
export var fulfillmentGroupTable = "_54-e";
export var largeText = "_54-3";
export var loadingSpinnerContainer = "_54-j";
export var mediumText = "_54-2";
export var narrow = "_54-f";
export var notificationLink = "_54-l";
export var packageCheckIconContainer = "_54-7";
export var slideoutHeaderActions = "_54-g";
export var slideoutHeaderActionsShifted = "_54-h";
export var slideoutHeaderContainer = "_54-a";
export var slideoutModal = "_54-c";
export var stickyHeaderWrapper = "_54-b";
export var table = "_54-k";
export var tableContainer = "_54-d";
export var tertiaryText = "_54-1";